import React from "react";
import Checkbox from "../ui/Checkbox";

const ratings = ["5", "4", "3+"];
const facilities = [
  { label: "Parking", value: "parking" },
  { label: "Pets Allowed", value: "Pets allowed" },
  { label: "A/C", value: "Air conditioning" },
  { label: "Room Service", value: "Room service" },
  { label: "Complementary Breakfast", value: "breakfast" },
  { label: "Pool", value: "pool" },
  { label: "Spa", value: "spa" },
  { label: "Meeting Rooms", value: "Meeting rooms" },
  { label: "Restaurant", value: "Restaurant" },
];
const propertyTypes = [
  { label: "Hotel", value: "hotel" },
  { label: "Villa", value: "villa" },
  { label: "Apartment", value: "apartment" },
  { label: "Hostel", value: "hostel" },
];
const reservationPolicies = [
  { label: "Free Cancellation", value: "free_cancellation" },
  { label: "Book without Credit Card", value: "no_credit_card" },
  { label: "No Prepayment", value: "no_prepayment" },
];

interface HotelFilterbarProps {
  selectedRatings: string[];
  setSelectedRatings: React.Dispatch<React.SetStateAction<string[]>>;
  selectedFacilities: string[];
  setSelectedFacilities: React.Dispatch<React.SetStateAction<string[]>>;
  selectedPropertyTypes: string[];
  setSelectedPropertyTypes: React.Dispatch<React.SetStateAction<string[]>>;
  price: number;
  setPrice: React.Dispatch<React.SetStateAction<number>>;
  selectedPolicies: string[];
  setSelectedPolicies: React.Dispatch<React.SetStateAction<string[]>>;
}

const HotelFilterbar = ({
  selectedRatings,
  setSelectedRatings,
  selectedFacilities,
  setSelectedFacilities,
  selectedPropertyTypes,
  setSelectedPropertyTypes,
  price,
  setPrice,
  selectedPolicies,
  setSelectedPolicies,
}: HotelFilterbarProps) => {
  const handleToggle = (
    value: string,
    selectedList: string[],
    setter: (val: string[]) => void,
  ) => {
    setter(
      selectedList.includes(value)
        ? selectedList.filter((item) => item !== value)
        : [...selectedList, value],
    );
  };

  return (
    <div className="bg-[#F5F8FF] p-4 rounded-xl min-w-72 shadow-md text-black space-y-5">
      {/* Rating */}
      <div className="space-y-2">
        <div className="flex justify-between items-center text-subheading border-b border-black pb-2">
          <span>Rating</span>
        </div>
        <div className="flex flex-wrap gap-3 pt-2 text-sm">
          {ratings.map((label) => (
            <label key={label} className="flex items-center gap-2">
              <Checkbox
                id={`rating-${label}`}
                name={`rating-${label}`}
                checked={selectedRatings.includes(label)}
                onChange={() =>
                  handleToggle(label, selectedRatings, setSelectedRatings)
                }
              />
              {label}
            </label>
          ))}
        </div>
      </div>

      {/* Facilities */}
      <div className="space-y-2">
        <div className="flex justify-between items-center text-subheading border-b border-black pb-2">
          <span>Facilities</span>
        </div>
        <div className="grid grid-cols-2 gap-2 pt-2 text-sm">
          {facilities.map((facility) => (
            <label key={facility.value} className="flex items-center gap-2">
              <Checkbox
                id={`facility-${facility.value}`}
                name={`facility-${facility.value}`}
                checked={selectedFacilities.includes(facility.value)}
                onChange={() =>
                  handleToggle(
                    facility.value,
                    selectedFacilities,
                    setSelectedFacilities,
                  )
                }
              />
              {facility.label}
            </label>
          ))}
        </div>
      </div>

      {/* Property Type */}
      <div className="space-y-2">
        <div className="flex justify-between items-center text-subheading border-b border-black pb-2">
          <span>Property Type</span>
        </div>
        <div className="grid grid-cols-2 gap-2 pt-2 text-sm">
          {propertyTypes.map((type) => (
            <label key={type.value} className="flex items-center gap-2">
              <Checkbox
                id={`property-${type.value}`}
                name={`property-${type.value}`}
                checked={selectedPropertyTypes.includes(type.value)}
                onChange={() =>
                  handleToggle(
                    type.value,
                    selectedPropertyTypes,
                    setSelectedPropertyTypes,
                  )
                }
              />
              {type.label}
            </label>
          ))}
        </div>
      </div>

      {/* Price */}
      <div className="space-y-2">
        <div className="flex justify-between items-center text-subheading border-b border-black pb-2">
          <span>Price</span>
        </div>
        <div className="flex items-center justify-between text-sm mb-2 pt-2">
          <span>Below 500</span>
          <span>26000</span>
        </div>
        <input
          type="range"
          min={500}
          max={26000}
          step={100}
          value={price}
          onChange={(e) => setPrice(Number(e.target.value))}
          className="w-full accent-primary cursor-pointer"
        />
      </div>

      {/* Reservation Policy */}
      <div className="space-y-2">
        <div className="flex justify-between items-center text-subheading border-b border-black pb-2">
          <span>Reservation Policy</span>
        </div>
        <div className="flex flex-col gap-2 pt-2 text-sm">
          {reservationPolicies.map((policy) => (
            <label key={policy.value} className="flex items-center gap-2">
              <Checkbox
                id={`policy-${policy.value}`}
                name={`policy-${policy.value}`}
                checked={selectedPolicies.includes(policy.value)}
                onChange={() =>
                  handleToggle(
                    policy.value,
                    selectedPolicies,
                    setSelectedPolicies,
                  )
                }
              />
              {policy.label}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HotelFilterbar;
